import { Box, Grid, Typography } from '@mui/material';
import { ApplicationProps } from '../../redux-store/types/api-types';
import { Gridstyles } from '../Investments/investor-application';
import { KeyValue } from './contributor';
import { SubHeading } from '../investors/components';
import { CustodianMaster, NonCustodianMaster } from '../../utils/constant';
import { checkIfApplicationIsNonIndividual, isNotAdvisoryFlow } from '../../utils/utilityFunctions';

export default function DistributorDetails({
  application,
}: {
  application: ApplicationProps;
}): JSX.Element {
  const employeeCommonComponent = (
    <>
      {application && checkIfApplicationIsNonIndividual(application) ? (
        <>
          <KeyValue title={'Employee Name'} description={application?.employeeName} />
          <KeyValue title={'Employee Code'} description={application?.employeeCode} />
          <KeyValue title={'Employee Designation'} description={application?.employeeDesignation} />
          <KeyValue title={'Employee Branch'} description={application?.employeeBranch} />
        </>
      ) : (
        <></>
      )}
    </>
  );
  const custodians =
    application && checkIfApplicationIsNonIndividual(application as ApplicationProps)
      ? NonCustodianMaster
      : CustodianMaster;
  return (
    <>
      <Box
        sx={{
          bgcolor: 'white',
          boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.05)',
          borderRadius: '10px',
        }}>
        <Box sx={{ p: 2 }}>
          <Grid container sx={{ mt: 1, pl: { xs: 2, sm: 10 }, pr: { xs: 2, sm: 10 } }}>
            <Grid container direction="row" justifyContent="space-between" alignItems="flex-start">
              <Typography
                component="h2"
                sx={{ fontSize: 18, fontWeight: 600, color: 'primary.main' }}>
                Maker Details
              </Typography>
            </Grid>

            {application.srm_id && (
              <Box sx={{ width: '100%' }}>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  SRM Details
                </SubHeading>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pt={1}
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue title={"SRM's Name"} description={application?.srm?.name} />
                    <KeyValue
                      title={"SRM's Email Address"}
                      description={application?.srm?.user?.email}
                    />
                    <KeyValue
                      title={"SRM's Mobile Number"}
                      description={application?.srm?.user?.phone}
                    />
                    {employeeCommonComponent}
                  </Grid>
                </Gridstyles>
              </Box>
            )}
            {application?.distributor && (
              <Box sx={{ width: '100%' }}>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  Distributor Details
                </SubHeading>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pt={1}
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue
                      title={'Distributor Code'}
                      description={application?.distributor?.arnCode}
                    />
                    <KeyValue
                      title={'Distributor/IFA Name'}
                      description={application?.distributor?.name}
                    />
                    {employeeCommonComponent}
                    {application?.distributor?.type !== 'company' && (
                      <>
                        <KeyValue
                          title={'Distributor/IFA APRN Number'}
                          description={application?.distributor?.aprn}
                        />
                        <KeyValue
                          title={'Distributor/IFA EUIN Number'}
                          description={application?.distributor?.euin}
                        />
                      </>
                    )}
                    <KeyValue
                      title={"Distributor's RM Code"}
                      description={application?.subDistributor?.distributors_RM_Code}
                    />
                    <KeyValue
                      title={"Distributor's RM Name"}
                      description={application?.subDistributor?.user?.firstName}
                    />
                    {application?.distributor.type === 'company' && (
                      <>
                        <KeyValue
                          title={"Distributor's RM APRN Number"}
                          description={application?.subDistributor?.aprn}
                        />
                        <KeyValue
                          title={"Distributor's RM EUIN Number"}
                          description={application?.subDistributor?.euin}
                        />
                      </>
                    )}
                    <KeyValue
                      title={'Distributor RM/IFA Email'}
                      description={
                        application?.subDistributor?.user?.email ||
                        application?.distributor?.user?.email
                      }
                    />
                    {/* <KeyValue title={'AMCs RM/Advisor Name - Location'} description={null} /> */}
                    <KeyValue title={'Filled By'} description={application?.filledBy} />
                    {/* <KeyValue
                      title={'Custodian Name'}
                      description={CustodianMaster[application?.custodian || '']}
                    /> */}
                  </Grid>
                </Gridstyles>
              </Box>
            )}
            {application.rm_id && (
              <Box sx={{ width: '100%' }}>
                <SubHeading
                  sx={{
                    color: 'common.black',
                    letterSpacing: 0.5 + 'px',
                    padding: { xs: '10px 10px', sm: '10px 30px' },
                  }}>
                  RM Details
                </SubHeading>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pt={1}
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    <KeyValue title={'RM Name'} description={application?.rm?.name} />
                    <KeyValue
                      title={"RM's Email Address"}
                      description={application?.rm?.user?.email}
                    />
                    {employeeCommonComponent}
                    <KeyValue
                      title={"RM's Mobile Number"}
                      description={application?.rm?.user?.phone}
                    />
                    <KeyValue
                      title={"RM's NISM Certificate Number"}
                      description={application?.rm?.nismNumber}
                    />
                    <KeyValue title={"RM's APRN Number"} description={application?.rm?.aprn} />
                    <KeyValue title={"RM's EUIN Number"} description={application?.rm?.euin} />
                  </Grid>
                </Gridstyles>
              </Box>
            )}
            {isNotAdvisoryFlow(application?.accountType || '') && (
              <Box sx={{ width: '100%' }}>
                <Gridstyles>
                  <Grid
                    item
                    container
                    pt={1}
                    pb={5}
                    rowSpacing={6}
                    columnSpacing={13}
                    direction="row"
                    justifyContent="space-between"
                    alignItems="flex-start">
                    {application?.custodian && (
                      <KeyValue
                        title="Custodian Name"
                        description={custodians[application?.custodian || '']}
                      />
                    )}
                  </Grid>
                </Gridstyles>
              </Box>
            )}
          </Grid>
        </Box>
      </Box>
    </>
  );
}
